import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import MultiSelect from './MultiSelect';
import CategoryMultiSelect from './CategoryMultiSelect';
import { TYPE_EBOOK, CLIENT_TYPES, AUDIOBOOK_FORMATS } from './constants';

function Limite({ label, value, onChange }) {
    return (
        <div className="col-4">
            <label className="form-label text-white-50">{label} (-1 = ilimitado)</label>
            <div className="input-group">
                <input
                    type="number"
                    className="form-control bg-dark text-white border-secondary py-2"
                    value={value.min === '' ? '' : value.min}
                    onChange={(e) => onChange({ ...value, min: e.target.value === '' ? '' : Number(e.target.value) })}
                    placeholder="min"
                />
                <input
                    type="number"
                    className="form-control bg-dark text-white border-secondary py-2"
                    value={value.max === '' ? '' : value.max}
                    onChange={(e) => onChange({ ...value, max: e.target.value === '' ? '' : Number(e.target.value) })}
                    placeholder="max"
                />
            </div>
        </div>
    );
}

function FlagSwitch({ label, field, epubs, setEpubs }) {
    return (
        <div className="form-check form-switch">
            <input
                type="checkbox"
                className="form-check-input"
                role="switch"
                id={`epub-${field}`}
                checked={!!epubs[field]}
                onChange={(e) => setEpubs({ ...epubs, [field]: e.target.checked ? 1 : 0 })}
            />
            <label className="form-check-label text-white" htmlFor={`epub-${field}`}>{label}</label>
        </div>
    );
}

export function ValidationChannelForm({ initial, content, onSubmit, saving, onCancel }) {
    const [form, setForm] = useState({
        advice: '',
        advice_en: '',
        type_ebook: [],
        requirements_ebook: {
            restriction_into: { epubs: {}, pdf: {} },
            limit_page: { min: 0, max: -1 },
            limit_price: { min: 0, max: -1 },
            limit_size: { min: 0, max: -1 },
        },
        requirements_audiobook: { formats: [], sample: 0 },
        client_type: [],
        allow_no_isbn: 0,
        allowed_categories: { bisac: [], thema: [] },
    });

    useEffect(() => {
        const base = initial || {};
        setForm({
            advice: base.advice || '',
            advice_en: base.advice_en || '',
            type_ebook: base.type_ebook || [],
            requirements_ebook: {
                restriction_into: {
                    epubs: (base.requirements_ebook && base.requirements_ebook.restriction_into && base.requirements_ebook.restriction_into.epubs) || {},
                    pdf: (base.requirements_ebook && base.requirements_ebook.restriction_into && base.requirements_ebook.restriction_into.pdf) || {},
                },
                limit_page: (base.requirements_ebook && base.requirements_ebook.limit_page) || { min: 0, max: -1 },
                limit_price: (base.requirements_ebook && base.requirements_ebook.limit_price) || { min: 0, max: -1 },
                limit_size: (base.requirements_ebook && base.requirements_ebook.limit_size) || { min: 0, max: -1 },
            },
            requirements_audiobook: {
                formats: (base.requirements_audiobook && base.requirements_audiobook.formats) || [],
                sample: (base.requirements_audiobook && base.requirements_audiobook.sample) || 0,
            },
            client_type: base.client_type || [],
            allow_no_isbn: (base.allow_no_isbn !== undefined && base.allow_no_isbn !== null) ? base.allow_no_isbn : 0,
            allowed_categories: {
                bisac: (base.allowed_categories && base.allowed_categories.bisac) || [],
                thema: (base.allowed_categories && base.allowed_categories.thema) || [],
            },
        });
    }, [initial]);

    const set = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const hasEbook = content.includes('ebook');
    const hasAudiobook = content.includes('audiobook');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            advice: form.advice,
            advice_en: form.advice_en,
            type_ebook: hasEbook ? form.type_ebook : [],
            requirements_ebook: hasEbook ? form.requirements_ebook : {},
            requirements_audiobook: hasAudiobook ? form.requirements_audiobook : {},
            client_type: form.client_type,
            allow_no_isbn: form.allow_no_isbn,
            allowed_categories: { bisac: form.allowed_categories.bisac, thema: form.allowed_categories.thema },
        });
    };

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3">
                {hasEbook && (
                    <>
                        <div className="col-12">
                            <label className="form-label text-white-50">Formatos ebook</label>
                            <MultiSelect
                                options={TYPE_EBOOK}
                                value={form.type_ebook}
                                onChange={(v) => set('type_ebook', v)}
                                placeholder="Formatos permitidos..."
                            />
                        </div>
                        <div className="col-12">
                            <div className="rounded-3 border border-secondary border-opacity-25 p-3">
                                <h6 className="text-white mb-2">Restricciones</h6>
                                <div className="d-flex gap-4 mb-3">
                                    <FlagSwitch label="EPUB: JavaScript" field="javascript" epubs={form.requirements_ebook.restriction_into.epubs} setEpubs={(epubs) => set('requirements_ebook', { ...form.requirements_ebook, restriction_into: { ...form.requirements_ebook.restriction_into, epubs } })} />
                                    <FlagSwitch label="EPUB: Multimedia" field="multimedia" epubs={form.requirements_ebook.restriction_into.epubs} setEpubs={(epubs) => set('requirements_ebook', { ...form.requirements_ebook, restriction_into: { ...form.requirements_ebook.restriction_into, epubs } })} />
                                </div>
                                <div className="row g-3">
                                    <Limite label="Páginas" value={form.requirements_ebook.limit_page} onChange={(v) => set('requirements_ebook', { ...form.requirements_ebook, limit_page: v })} />
                                    <Limite label="Precio (USD)" value={form.requirements_ebook.limit_price} onChange={(v) => set('requirements_ebook', { ...form.requirements_ebook, limit_price: v })} />
                                    <Limite label="Tamaño (MB)" value={form.requirements_ebook.limit_size} onChange={(v) => set('requirements_ebook', { ...form.requirements_ebook, limit_size: v })} />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {hasAudiobook && (
                    <div className="col-12">
                        <div className="rounded-3 border border-secondary border-opacity-25 p-3">
                            <h6 className="text-white mb-2">Requisitos audiolibro</h6>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label text-white-50">Formatos</label>
                                    <MultiSelect
                                        options={AUDIOBOOK_FORMATS}
                                        value={form.requirements_audiobook.formats}
                                        onChange={(v) => set('requirements_audiobook', { ...form.requirements_audiobook, formats: v })}
                                        placeholder="Formatos permitidos..."
                                    />
                                </div>
                                <div className="col-md-6 d-flex align-items-end">
                                    <div className="form-check form-switch">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            role="switch"
                                            id="sample-audiobook"
                                            checked={!!form.requirements_audiobook.sample}
                                            onChange={(e) => set('requirements_audiobook', { ...form.requirements_audiobook, sample: e.target.checked ? 1 : 0 })}
                                        />
                                        <label className="form-check-label text-white" htmlFor="sample-audiobook">Permite muestra (sample)</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="col-md-6">
                    <label className="form-label text-white-50">Tipo de cliente</label>
                    <MultiSelect
                        options={CLIENT_TYPES}
                        value={form.client_type}
                        onChange={(v) => set('client_type', v)}
                        placeholder="Clientes permitidos..."
                    />
                </div>
                <div className="col-md-6">
                    <label className="form-label text-white-50">Permite ISBN (allow_no_isbn)</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={form.allow_no_isbn}
                        onChange={(e) => set('allow_no_isbn', Number(e.target.value))}
                    >
                        <option value={0}>Requiere ISBN</option>
                        <option value={1}>Permite sin ISBN</option>
                    </select>
                </div>

                <div className="col-md-6">
                    <label className="form-label text-white-50">Categorías BISAC</label>
                    <CategoryMultiSelect
                        type="bisac"
                        value={form.allowed_categories.bisac}
                        onChange={(v) => set('allowed_categories', { ...form.allowed_categories, bisac: v })}
                        placeholder="Buscar categorías BISAC..."
                    />
                </div>
                <div className="col-md-6">
                    <label className="form-label text-white-50">Categorías THEMA</label>
                    <CategoryMultiSelect
                        type="thema"
                        value={form.allowed_categories.thema}
                        onChange={(v) => set('allowed_categories', { ...form.allowed_categories, thema: v })}
                        placeholder="Buscar categorías THEMA..."
                    />
                </div>

                <div className="col-md-6">
                    <label className="form-label text-white-50">Advice (ES)</label>
                    <textarea
                        className="form-control bg-dark text-white border-secondary py-2"
                        rows={3}
                        value={form.advice}
                        onChange={(e) => set('advice', e.target.value)}
                        placeholder="Texto informativo mostrado al elegir el canal"
                    />
                </div>
                <div className="col-md-6">
                    <label className="form-label text-white-50">Advice (EN)</label>
                    <textarea
                        className="form-control bg-dark text-white border-secondary py-2"
                        rows={3}
                        value={form.advice_en}
                        onChange={(e) => set('advice_en', e.target.value)}
                    />
                </div>
            </div>

            <div className="d-flex justify-content-end mt-4 pt-3 border-top border-secondary border-opacity-25">
                <button type="button" className="btn btn-outline-secondary px-4 me-2" onClick={onCancel} disabled={saving}>Cancelar</button>
                <button type="submit" className="btn btn-success px-4" disabled={saving}>
                    {saving ? <FontAwesomeIcon icon={faSpinner} spin className="me-1" /> : null}
                    Guardar validación
                </button>
            </div>
        </form>
    );
}

export default ValidationChannelForm;